import { Component, createRef } from "react"

/* Components */
import { DataLayout, Pagination, Icon, Avatar } from "../../components"

/* Widgets */
import { UserModal } from "../../widgets/user"
import { MasterModal } from "../../widgets/master"
import { toast } from "../../widgets/common"

/* Helpers */
import { withRouter } from "../../helpers"

/* Shared */
import { initialsOf, avatarColorOf, ago } from "../../widgets/user/shared"
import { plural } from "../../widgets/category/shared"

/* Constants */
import { env } from "../../constants"

/* REST API */
import { list } from "../../api/OTP"

/* Moment */
import moment from "moment"


/* Who asked for the code */
const TYPES = {
    user: { text: "Клиент", hint: "Bookify — приложение и сайт", accent: "blue", icon: "user" },
    member: { text: "Мастер", hint: "Bookify Pro", accent: "violet", icon: "master" }
}

/* What became of a code — the server reads it from the account behind the phone */
const RESULTS = {
    entered: { text: "Вошёл", accent: "green", icon: "check", hint: "Последний код номера, аккаунт вошёл" },
    waiting: { text: "Ждёт ввода", accent: "orange", icon: "clock", hint: "Код ещё живой — пять минут с отправки" },
    missed: { text: "Не введён", accent: "red", icon: "close", hint: "Последний код номера истёк, входа не было" },
    repeated: { text: "Запросил снова", accent: "orange", icon: "refresh", hint: "Через несколько минут номер попросил новый код — этот, скорее всего, не дошёл" },
    past: { text: "Прошлый вход", accent: "grey", icon: "eye", hint: "Старый код номера, позже были новые" },
    none: { text: "Нет аккаунта", accent: "grey", icon: "alert", hint: "Аккаунта с этим номером больше нет" }
}

/* The periods of the list */
const PERIODS = [
    { key: "", text: "Всё время" },
    { key: "today", text: "Сегодня" },
    { key: "week", text: "7 дней" },
    { key: "month", text: "30 дней" }
]

/* The empty filters */
const INITIAL = { search: "", type: "", period: "", view: "" }


/* Page OTP Logs — every code of the entrance the apps sent: who asked, whether the code was typed,
   and the phones which ask too often. A row opens the card of the client or of the master */
class OtpLogs extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            count: 0,
            limit: 30,
            page: 1,
            statistics: null,
            days: [],
            attention: [],
            ...INITIAL
        }

        this._user = createRef()
        this._master = createRef()
        this._timer = null
    }

    componentDidMount = () => {

        window.scrollTo(0, 0)
        this.load(1, true)
    }

    componentWillUnmount = () => {
        clearTimeout(this._timer)
    }

    load = (page = 1, reload = false) => {

        /* Fields */
        const { search, type, period, view } = this.state

        if (reload) {
            this.setState({ status: "loading" })
        }

        this.setState({ page })

        list({ page, search, type, period, view }).then(response => {
            if (response && response.status === 200) {
                this.setState({
                    status: "ok",
                    data: response.data.list,
                    count: response.data.count,
                    limit: response.data.limit,
                    statistics: response.data.statistics,
                    days: response.data.days,
                    attention: response.data.attention
                })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }

    /* Every filter starts from the first page */
    refilter = fields => {
        this.setState(fields, () => this.load(1, true))
    }

    /* The search waits for the hand to stop */
    searchText = text => {

        clearTimeout(this._timer)
        this.setState({ search: text })

        this._timer = setTimeout(() => this.load(1, true), text.length === 0 ? 0 : 450)
    }

    /* A filter pressed twice lets go */
    toggle = (field, value, empty) => {
        this.refilter({ [field]: this.state[field] === value ? empty : value })
    }

    /* The code goes to the clipboard — the team reads it to a client on the phone */
    copy = (event, code) => {

        event.stopPropagation()

        if (!navigator.clipboard) {
            return
        }

        navigator.clipboard.writeText(code).then(() => toast.success("Код скопирован")).catch(() => { })
    }

    /* The card of the account behind the code */
    open = item => {

        if (!item.accountID) {
            return
        }

        if (item.type === "member") {
            this._master.current.open({ id: item.accountID, name: item.name, phone: item.phone, image: item.image })
        }
        else {
            this._user.current.open({ id: item.accountID, name: item.name, phone: item.phone, image: item.image, active: item.active, verified: item.verified })
        }
    }

    _header = () => {

        /* Fields */
        const { search } = this.state

        return (
            <div className="organization-header">

                <div className="page-header-text">OTP логи</div>

                <div className="organization-header-tools">
                    <form onSubmit={event => { event.preventDefault(); clearTimeout(this._timer); this.load(1, true) }} className="organization-search service-search">
                        <div className="organization-search-icon">
                            <Icon name="search" size={17} />
                        </div>
                        <input placeholder="Телефон или имя" value={search} onChange={event => this.searchText(event.target.value)} />
                        {search.length > 0 &&
                            <div onClick={() => this.searchText("")} className="organization-search-clear">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        }
                    </form>
                </div>

            </div>
        )
    }

    /* Today against yesterday, the two weeks as a chart, and the tiles */
    _summary = () => {

        /* Fields */
        const { statistics, days, attention, view } = this.state

        if (!statistics) {
            return null
        }

        /* Every day of the two weeks, the silent ones too */
        const chart = []

        for (let index = 13; index >= 0; index--) {
            const day = moment().subtract(index, "days")
            const row = days.find(item => moment(item.day).format("YYYY-MM-DD") === day.format("YYYY-MM-DD"))
            chart.push({ key: day.format("YYYY-MM-DD"), text: day.format("dd"), date: day.format("D MMM"), today: index === 0, users: row ? row.users : 0, members: row ? row.members : 0 })
        }

        const top = Math.max(...chart.map(item => item.users + item.members), 1)
        const difference = statistics.today - statistics.yesterday
        const rate = statistics.phones > 0 ? Math.round(statistics.entered / statistics.phones * 100) : null

        const tiles = [
            { key: "rate", icon: "check", value: rate === null ? "—" : `${rate}%`, text: `вошли · ${statistics.entered} из ${statistics.phones} номеров за 7 дней`, accent: rate !== null && rate < 70 ? "orange" : "green" },
            { key: "week", icon: "otp", value: statistics.week.toLocaleString("ru-RU"), text: `${plural(statistics.week, "код", "кода", "кодов")} за 7 дней`, accent: "blue" },
            { key: "flood", icon: "alert", value: attention.length.toLocaleString("ru-RU"), text: "номеров с 5+ кодами за сутки", accent: "red", filter: true },
            { key: "test", icon: "sparkle", value: statistics.test.toLocaleString("ru-RU"), text: "тестовых кодов 9999", accent: "violet", filter: true }
        ]

        return (
            <div className="otp-summary">

                <div className="user-summary-main otp-today">

                    <div className="user-summary-top">
                        <div>
                            <b>{statistics.today.toLocaleString("ru-RU")}</b>
                            <span>{plural(statistics.today, "код", "кода", "кодов")} сегодня · {statistics.phonesToday} {plural(statistics.phonesToday, "номер", "номера", "номеров")}</span>
                        </div>
                        <div className={`otp-difference ${difference > 0 ? "up" : (difference < 0 ? "down" : "")}`} title={`Вчера: ${statistics.yesterday}`}>
                            {difference > 0 ? "+" : ""}{difference} к вчера
                        </div>
                    </div>

                    <div className="otp-chart">
                        {chart.map(item =>
                            <div key={item.key} className={`otp-chart-column ${item.today ? "today" : ""}`} title={`${item.date}: клиенты ${item.users}, мастера ${item.members}`}>
                                <em>{item.users + item.members > 0 ? item.users + item.members : ""}</em>
                                <div className="otp-chart-stack" style={{ height: `${item.users + item.members > 0 ? Math.max(6, (item.users + item.members) / top * 100) : 0}%` }}>
                                    <i className="members" style={{ flex: item.members }} />
                                    <i className="users" style={{ flex: item.users }} />
                                </div>
                                <span>{item.text}</span>
                            </div>
                        )}
                    </div>

                    <div className="otp-legend">
                        <div><i className="users" />Клиенты · {statistics.todayUsers} сегодня</div>
                        <div><i className="members" />Мастера · {statistics.todayMembers} сегодня</div>
                    </div>

                </div>

                <div className="otp-tiles">
                    {tiles.map(tile =>
                        <div
                            key={tile.key}
                            onClick={() => tile.filter && this.toggle("view", tile.key, "")}
                            className={`user-tile ${tile.accent} ${tile.filter ? "clickable" : ""} ${view === tile.key ? "active" : ""}`}
                        >
                            <div className="user-tile-icon"><Icon name={tile.icon} size={16} width={2} /></div>
                            <b>{tile.value}</b>
                            <span>{tile.text}</span>
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* The phones which ask too often — a stuck client or somebody spending our messages */
    _attention = () => {

        /* Fields */
        const { attention } = this.state

        if (attention.length === 0) {
            return null
        }

        return (
            <div className="otp-attention">
                <div className="otp-attention-icon"><Icon name="alert" size={20} width={2} /></div>
                <div className="otp-attention-text">
                    <b>Слишком много кодов на один номер</b>
                    <span>5 и больше за сутки — клиент не может войти или кто-то тратит сообщения</span>
                </div>
                <div className="otp-attention-list">
                    {attention.map(item =>
                        <div key={`${item.phone}-${item.type}`} onClick={() => this.refilter({ search: `${item.phone}`.replace(/\D/g, ""), view: "" })} className="otp-attention-chip" title={item.name ? item.name : "Без имени"}>
                            <Icon name={TYPES[item.type] ? TYPES[item.type].icon : "user"} size={12} width={2.2} />
                            {item.phone}
                            <b>×{item.count}</b>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    _toolbar = () => {

        /* Fields */
        const { type, period, view, count } = this.state

        return (
            <div className="service-toolbar">

                <div className="service-segment">
                    <div onClick={() => this.refilter({ type: "" })} className={type === "" ? "active" : ""}>Все</div>
                    <div onClick={() => this.refilter({ type: "user" })} className={type === "user" ? "active" : ""}>Клиенты</div>
                    <div onClick={() => this.refilter({ type: "member" })} className={type === "member" ? "active" : ""}>Мастера</div>
                </div>

                <div onClick={() => this.toggle("view", "waiting", "")} className={`service-filter ${view === "waiting" ? "active" : ""}`} title="Последний код номера, который так и не ввели">
                    <Icon name="clock" size={15} width={2} />
                    Не вошли
                </div>

                {(view === "flood" || view === "test") &&
                    <div className="service-filter active">
                        <Icon name={view === "flood" ? "alert" : "sparkle"} size={15} width={2} />
                        {view === "flood" ? "Флуд за сутки" : "Тестовые 9999"}
                        <div onClick={() => this.refilter({ view: "" })} className="service-filter-clear"><Icon name="close" size={9} width={2.6} /></div>
                    </div>
                }

                <div className="user-count">{count.toLocaleString("ru-RU")} {plural(count, "код", "кода", "кодов")}</div>

                <div className="service-sort">
                    <Icon name="calendar" size={15} width={1.9} />
                    {PERIODS.map(item =>
                        <div key={item.key} onClick={() => this.refilter({ period: item.key })} className={period === item.key ? "active" : ""}>{item.text}</div>
                    )}
                </div>

            </div>
        )
    }

    /* One code of the list */
    _item = item => {

        const type = TYPES[item.type] ? TYPES[item.type] : TYPES.user
        const result = RESULTS[item.result] ? RESULTS[item.result] : RESULTS.past
        const name = item.name && `${item.name}`.trim().length > 0 ? `${item.name}`.trim() : null
        const folder = item.type === "member" ? "members" : "users"
        const image = item.image ? `${env.mediapoint}${folder}/${item.image}` : null

        return (
            <div key={`${item.id}`} onClick={() => this.open(item)} className={`otp-item ${item.accountID ? "" : "orphan"} ${item.flood ? "flood" : ""}`}>

                <div className="user-item-cell person">
                    <div className="user-item-avatar-wrap" style={{ "--avatar": avatarColorOf(item.accountID) }}>
                        <Avatar className="user-item-avatar" src={image} alt={name}>
                            {name ? <span>{initialsOf(name)}</span> : <Icon name={type.icon} size={20} width={2} />}
                        </Avatar>
                    </div>
                    <div className="user-item-title">
                        <div className="user-item-name">{item.phone}</div>
                        <div className="user-item-phone">{name ? name : (item.accountID ? "Без имени" : "Аккаунта нет")}</div>
                    </div>
                </div>

                <div className="otp-item-code">
                    <div onClick={event => this.copy(event, item.code)} className={`otp-code ${item.code === "9999" ? "test" : ""}`} title="Скопировать код">
                        {`${item.code}`.split("").map((digit, index) => <i key={index}>{digit}</i>)}
                    </div>
                </div>

                <div className="otp-item-type">
                    <div className={`user-badge ${type.accent}`} title={type.hint}><Icon name={type.icon} size={12} width={2.2} />{type.text}</div>
                </div>

                <div className="otp-item-result">
                    <div className={`user-badge ${result.accent}`} title={result.hint}><Icon name={result.icon} size={11} width={2.6} />{result.text}</div>
                </div>

                <div className="otp-item-attempts">
                    {item.daily > 1
                        ? <b className={item.flood ? "flood" : ""}>{item.daily}-й за сутки</b>
                        : <b>первый за сутки</b>
                    }
                    <span>{item.total} {plural(item.total, "код", "кода", "кодов")} всего</span>
                </div>

                <div className="otp-item-time">
                    <b>{moment(item.createdAt).format("HH:mm")}</b>
                    <span>{ago(item.createdAt)}</span>
                </div>

            </div>
        )
    }

    /* The list split by the days */
    _list = () => {

        /* Fields */
        const { data } = this.state

        const groups = []

        data.forEach(item => {

            const day = moment(item.createdAt).format("YYYY-MM-DD")
            const last = groups[groups.length - 1]

            if (last && last.day === day) {
                last.items.push(item)
            }
            else {
                groups.push({ day, items: [item] })
            }
        })

        return groups.map(group => {

            const date = moment(group.day)

            let label = date.isSame(moment(), "year") ? date.format("D MMMM, dddd") : date.format("D MMMM YYYY")

            if (date.isSame(moment(), "day")) {
                label = "Сегодня"
            }
            else if (date.isSame(moment().subtract(1, "day"), "day")) {
                label = "Вчера"
            }

            return (
                <div className="transaction-day" key={group.day}>
                    <div className="transaction-day-head">
                        <b>{label}</b>
                    </div>
                    {group.items.map(item => this._item(item))}
                </div>
            )
        })
    }

    _content = () => {

        /* Fields */
        const { status, data, count, page, limit } = this.state

        if (status !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    {this._summary()}
                    {this._attention()}
                    {this._toolbar()}
                    <DataLayout status={status} reload={() => this.load(1, true)} data={data} onReset={() => this.refilter({ ...INITIAL })} />
                </div>
            )
        }

        return (
            <div className="page-content">

                {this._summary()}
                {this._attention()}
                {this._toolbar()}

                <div className="service-list transaction-list">
                    {this._list()}
                </div>

                <Pagination size={limit} page={page} total={count} onPageChange={page => { window.scrollTo(0, 0); this.load(page, true) }} />

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { navigate } = this.props

        return (
            <div className="page">

                {this._header()}

                {this._content()}

                <UserModal ref={this._user} onChanged={() => this.load(this.state.page)} />
                <MasterModal ref={this._master} onOrganization={id => navigate(`/organization?open=${id}`)} />

            </div>
        )
    }
}

export default withRouter(OtpLogs)
